import {
  Form,
  Input,
  InputNumber,
  notification,
  Radio,
  Select,
  Tag,
} from "antd";
import React, { useEffect, useState } from "react";
import Icon from "../../../assets/Icon";
import Lottie from "react-lottie";
import generateLottie from "../../../assets/lotties/GenerateJD.json";
import DropFileInput from "../../common/DropFileInput";
import WebUtils from "../../../utils/WebUtils";
import Utils from "../../../utils/Utils";
import {
  createGuideApi,
  generateJdPostApi,
  getModuleAccessInfoApi,
} from "../../../api/candidate";
import Loader from "../../Loader";
import GenerateJdAiText from "./GenerateJdAiText";
import "../../../styles/create-prep-main.css";
import BookLoader from "../../BookLoader";
import NoCreditModal from "./NoCreditModal";
const { Option } = Select;

const userDetail = Utils.getUserDetail();
let userRole = userDetail?.userRole;

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData: generateLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const jdOptions = [
  {
    label: "Generate JD",
    value: "generateJD",
  },
  {
    label: "Upload Manually",
    value: "uploadManually",
  },
];

function CreatePrepGuideMainPage({
  setSteps,
  setmanualGuideFlag,
  setJdId,
  setOpenCreateJdModal,
  backButtonHide,
  getAllJds,
}) {
  const [form] = Form.useForm();

  const [jdOptionValue, setJdOptionValue] = useState("generateJD");
  const [loading, setLoading] = useState(false);
  const [aiLoading, setAiLoading] = useState(false);
  const [resumeFile, setResumeFile] = useState({});
  const [resumeName, setResumeName] = useState();
  const [tags, setTags] = useState([]);
  const [tagInputValue, setTagInputValue] = useState("");
  const [isDraft, setIsDraft] = useState(false);
  const [generateJDtext, setGenerateJDtext] = useState(null);
  const [locationArr, setLocationArr] = useState([]);
  const [locationArrSecond, setLocationArrSecond] = useState([]);
  const [errorTag, setErrorTag] = useState(false);
  const [errorAiFile, setErrorAiFile] = useState(false);

  const [formData, setFormData] = useState({
    company: "",
    experience: "",
    location: "",
    tags: [],
    jobTitle: "",
  });

  const handleTagRemove = (removedTag) => {
    setTags(tags.filter((tag) => tag !== removedTag));
  };

  const handleInputConfirm = () => {
    const normalizedInputValue = tagInputValue.trim().toLowerCase();

    if (
      tagInputValue &&
      !tags.some((tag) => tag.toLowerCase() === normalizedInputValue)
    ) {
      setErrorTag(false);
      setTags([...tags, tagInputValue]);
    } else if (tags.some((tag) => tag.toLowerCase() === normalizedInputValue)) {
      setErrorTag(true);
      return;
    }

    // Reset the input field
    setTagInputValue("");
  };

  const handleFinish = (values, res) => {
    handleSubmit(values);
  };
  const jdOptionChange = ({ target: { value } }) => {
    setJdOptionValue(value);
  };
  const onFileChange = async (files) => {
    setErrorAiFile(null);
    if (files[0].size > 3145728) {
      // setFileError("file Size Cannot be more then 1MB");
      alert("file Size Cannot be more then 3MB");
      setResumeName("");
      return;
    } else {
      // setShowFileUploadAlert(true);
      setResumeName(files[0].name);
      setResumeFile(files[0]);
      setGenerateJDtext(null);
    }
  };

  const handleSubmit = (value) => {
    if (!isDraft) {
      if (!generateJDtext && !resumeName) {
        notification.warning({
          message: "Incomplete",
          description: "Please generate JD or upload file!",
        });
        setErrorAiFile(true);
        return;
      }
    }
    const url = `${createGuideApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;
    setLoading(true);

    let reqBody = {
      jobTitle: value.jobTitle,
      companyName: value.company,
      jobLocation: value.location,
      // isDraft: isDraft,
      isJdFile: resumeName ? true : false,
      jdText: generateJDtext ? generateJDtext : null,
      userRole: userRole,
      yearsOfExperience: value.experience,
      tags: tags,
    };

    let formdata = new FormData();
    formdata.append("createNewJdRequest", JSON.stringify(reqBody));
    formdata.append("jdFile", resumeFile);

    // console.log(reqBody);

    WebUtils.httpOperations(url, formdata, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          if (backButtonHide) {
            notification.success({
              message: "Success",
              description: `${
                isDraft ? "Guide saved as draft" : "Guide created successfully"
              }`,
              placement: "topRight",
              showProgress: true,
              duration: 2,
            });
            setOpenCreateJdModal(false);
            getAllJds();
          }
          // setTimeout(() => {
          //   window.location.href = "/preparation";
          // }, 2000);
          setJdId(result.data.data);
          setSteps(2);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "failure"
        ) {
          notification.error({
            message: "Failed",
            description: "Failed to create new guide!",
            placement: "topRight",
            showProgress: true,
          });
        } else if (
          result.data.resultStatusInfo.resultCode === "INSUFFICIENT_CREDITS"
        ) {
          notification.warning({
            message: "Insufficient credits",
            description: "Please contact us at support@hireplusplus.com !",
            placement: "topRight",
            showProgress: true,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission on Enter
    }
  };

  const handleSaveDraft = (e) => {
    // e.preventDefault()
    setIsDraft(true);
  };
  const handleCreateGuide = () => {
    setIsDraft(false);
  };

  const generatePostApi = (value) => {
    let url = `${generateJdPostApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;
    // console.log(formData);
    let reqBody = {
      jobTitle: formData.jobTitle,
      companyName: formData.company,
      jobLocation: formData.location,
      yearsOfExperience: formData.experience,
      tags: tags,
    };
    // console.log(reqBody);
    setAiLoading(true);
    WebUtils.httpOperations(url, reqBody, "POST")
      .then((result) => {
        setAiLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          // console.log(result.data);
          setGenerateJDtext(result.data.data);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "failure"
        ) {
          // console.log(result);
        }
      })
      .catch((err) => {
        setAiLoading(false);
        console.log(err);
      });
  };
  const handleGenerate = (e) => {
    e.preventDefault();
    setErrorAiFile(null);
    // console.log(formData.experience);
    if (!formData.jobTitle) {
      form.setFields([
        { name: "jobTitle", errors: ["Please input your job title!"] },
      ]);
    }
    if (!formData.company) {
      form.setFields([
        { name: "company", errors: ["Please input your company name!"] },
      ]);
    }
    if (!formData.location) {
      form.setFields([
        { name: "location", errors: ["Please select your location!"] },
      ]);
    }
    if (
      formData.experience === null ||
      formData.experience === undefined ||
      formData.experience === ""
    ) {
      form.setFields([
        {
          name: "experience",
          errors: ["Please select your experience!"],
        },
      ]);
    }
    if (
      formData.jobTitle &&
      formData.location &&
      formData.experience &&
      formData.company
    ) {
      setResumeFile(null);
      setResumeName(null);
      generatePostApi();
    }
  };

  const handleInputChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const callGeonamesAPI = async (query) => {
    try {
      const response = await fetch(
        `https://secure.geonames.org/searchJSON?name_startsWith=${query}&maxRows=10&countryBias=IN&cities=cities15000&username=hireplusplus`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      // console.log(data)
      setLocationArr(data.geonames);
      if (data.totalResultsCount === 0) {
        setLocationArrSecond([query]);
      }
      // console.log(data);
      // setSearchResults(data.geonames || []);
    } catch (error) {
      console.error("Error fetching data from Geonames API:", error);
      // setSearchResults([]);
    }
  };
  const onSearchLocation = (value, event) => {
    setLocationArrSecond([value]);

    if (value.length >= 2 && value.length % 2 === 0) {
      callGeonamesAPI(value);
    }
    // }
  };

  return (
    <>
      {loading && <Loader />}
      {aiLoading && <BookLoader />}

      <Form
        onFinish={handleFinish}
        form={form}
        layout="vertical"
        onKeyDown={handleKeyDown}
      >
        <div className="px-[0.8rem] lg:px-6 pb-[1rem]">
          {/* <p className="font-semibold text-[1rem]">Create New Guide</p> */}
          <div className="flex flex-col lg:flex-row gap-[1.5rem]  ">
            <div className="driver-new-guide-form w-full lg:w-[40%] border-2 shadow rounded-md lg:px-8 px-6  py-7 max-h-[550px] overflow-y-auto create-guide-form">
              <Form.Item
                className="p-0 mb-[15px] m-0"
                label={
                  <div className="text-[#475467] font-medium text-[.9rem] p-0 m-0">
                    Job Title
                  </div>
                }
                name="jobTitle"
                rules={[
                  { required: true, message: "Please input your job title!" },
                ]}
              >
                <Input
                  name="jobTitle"
                  size="large"
                  className="m-0"
                  placeholder="Ex. Frontend devloper"
                  onChange={handleInputChange}
                />
              </Form.Item>

              <Form.Item
                className="p-0 mb-[15px] m-0"
                label={
                  <div className="text-[#475467] font-medium text-[.9rem]">
                    Company
                  </div>
                }
                name="company"
                rules={[
                  {
                    required: true,
                    message: "Please input your company name!",
                  },
                ]}
              >
                <Input
                  size="large"
                  name="company"
                  // prefix={<Icon type="search-icon" />}
                  placeholder="Company name"
                  onChange={handleInputChange}
                />
              </Form.Item>
              <Form.Item
                className="p-0 mb-[15px] m-0"
                label={
                  <div className="text-[#475467] font-medium text-[.9rem]">
                    Location
                  </div>
                }
                name="location"
                rules={[
                  {
                    required: true,
                    message: "Please select your location!",
                  },
                ]}
              >
                <Select
                  showSearch
                  // className="w-100"
                  size="large"
                  placeholder="Location"
                  optionFilterProp="children"
                  onSearch={(e) => onSearchLocation(e)}
                  allowClear
                  // size="large"
                  onChange={(value) =>
                    handleInputChange({ target: { name: "location", value } })
                  }
                  notFoundContent="No Search found"
                  // filterOption={filterOption}
                >
                  {locationArr.map((location, index) => {
                    return (
                      <Select.Option
                        value={`${location.name},${location.countryName}`}
                        key={index}
                      >
                        {location.name},{location.countryName}
                      </Select.Option>
                    );
                  })}
                  {locationArrSecond.map((location, index) => {
                    return (
                      <Select.Option
                        value={`${location}`}
                        // key={index}
                      >
                        {location}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>

              <Form.Item
                className="p-0 mb-[15px] m-0"
                label={
                  <div className="text-[#475467] font-medium text-[.9rem]">
                    Years of Experience{" "}
                    <span className="text-gray-400">
                      (max. 40 years is allowed)
                    </span>
                  </div>
                }
                name="experience"
                rules={[
                  {
                    required: true,
                    message: "Please select your experience!",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value > 40) {
                        console.log(value);
                        return Promise.reject(
                          new Error("Experience cannot exceed 40 years")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                {/* <Select
                  name="experience" // Pass name as "experience"
                  size="large"
                  placeholder="Select years of experience"
                  onChange={(value) =>
                    handleInputChange({ target: { name: "experience", value } })
                  } // Update onChange to include name
                >
                  <Option value="0">Fresher</Option>
                  <Option value="1">1+ years</Option>
                  <Option value="2">2+ years</Option>
                  <Option value="3">3+ years</Option>
                  <Option value="5">5+ years</Option>
                </Select> */}
                <InputNumber
                  placeholder="years of experience"
                  name="experience"
                  className="w-full"
                  max={40}
                  size="large"
                  onChange={(value) =>
                    handleInputChange({
                      target: { name: "experience", value },
                    })
                  }
                />
              </Form.Item>

              <Form.Item
                className="p-0 m-0"
                label={
                  <div className="text-[#475467] font-medium text-[.9rem]">
                    Tags
                  </div>
                }
                validateStatus={errorTag ? "error" : null}
                help={errorTag ? "Tag already exists!" : null}
              >
                <Input
                  type="text"
                  size="large"
                  value={tagInputValue}
                  onChange={(e) => {
                    setTagInputValue(e.target.value);
                    setErrorTag(false);
                  }}
                  onPressEnter={handleInputConfirm}
                  disabled={tags.length > 9}
                  placeholder="Create tags and press Enter"
                  // onChange={handleInputChange}
                />

                <div
                  style={{ marginTop: "10px" }}
                  className="flex gap-y-2 flex-wrap"
                >
                  {tags.length === 0 ? (
                    <div className="flex gap-1 items-center">
                      <span>e.g.</span>
                      <Tag
                        // key={tag}
                        className="px-2"
                        // closable
                        disabled
                        // onClose={() => handleTagRemove(tag)}
                        color="default"
                        style={{ borderRadius: "16px" }}
                      >
                        HTML
                      </Tag>
                      <Tag
                        // key={tag}
                        className="px-2"
                        // closable
                        disabled
                        // onClose={() => handleTagRemove(tag)}
                        color="default"
                        style={{ borderRadius: "16px" }}
                      >
                        Spring Boot
                      </Tag>
                      <Tag
                        // key={tag}
                        className="px-2"
                        // closable
                        disabled
                        // onClose={() => handleTagRemove(tag)}
                        color="default"
                        style={{ borderRadius: "16px" }}
                      >
                        Java
                      </Tag>
                    </div>
                  ) : (
                    tags.map((tag, index) => (
                      <Tag
                        key={tag}
                        className="px-2 "
                        closable
                        onClose={() => handleTagRemove(tag)}
                        color={Utils.getTagColor(index)}
                        style={{ borderRadius: "16px" }}
                      >
                        {tag}
                      </Tag>
                    ))
                  )}
                </div>
              </Form.Item>
            </div>
            <div
              className={`${
                errorAiFile && "border border-red-500"
              } driver-job-description w-full lg:w-[60%] border-2 rounded-md p-4 shadow`}
            >
              <div className="flex gap-[0.8rem] flex-wrap justify-between  items-center">
                <div className="text-[#475467] font-medium text-[.95rem]">
                  Job Description
                </div>
                <div className="overflow-x-auto orange-scroll pb-1">
                  <Radio.Group
                    options={jdOptions}
                    onChange={jdOptionChange}
                    value={jdOptionValue}
                    optionType="button"
                    buttonStyle="solid"
                    className="flex whitespace-nowrap [&_.ant-radio-button-wrapper]:whitespace-nowrap"
                  />
                </div>
              </div>
              <div className="h-full flex items-center justify-center lg:pt-0 lg:pb-2 pt-1 pb-0">
                {jdOptionValue === "generateJD" ? (
                  generateJDtext ? (
                    <GenerateJdAiText
                      generateAiText={generateJDtext}
                      setGenerateJDtext={setGenerateJDtext}
                    />
                  ) : (
                    <div>
                      <Lottie
                        className=""
                        options={defaultOptions}
                        style={{
                          width: "100%",
                          maxWidth: "250px",
                          // marginTop: "20px",
                        }}
                      />
                      <p className="text-[#475467] font-medium text-center mt-[0.2rem] text-[.9rem]">
                        Create your Job Description with AI. Click{" "}
                        <b>Generate</b> to begin!
                      </p>
                      <p className="text-[#475467] font-medium text-center mt-[0.2rem] text-[.8rem]">
                        (Please fill the form to generate JD)
                      </p>
                      <button
                        onClick={handleGenerate}
                        className="btn-orange mt-[0.5rem] px-[1.2rem] py-[0.42rem] mb-1 flex gap-2 items-center text-[.875rem] mx-auto"
                      >
                        <Icon type="magic-icon" color="black" /> Generate JD
                      </button>
                    </div>
                  )
                ) : (
                  <div
                    className="py-6 w-full md:w-[70%] lg:w-[50%]   px-3 border-2  bg-[#FCFCFD] border-[#D0D5DD]  rounded-xl "
                    style={{ position: "relative" }}
                  >
                    <DropFileInput
                      onFileChange={(files) => onFileChange(files)}
                      resumeName={resumeName}
                      file={true}
                    />
                  </div>
                )}
              </div>
              {/* <p className="text-red-500">{errorAiFile && errorAiFile}</p> */}
            </div>
          </div>
          {/* <Divider /> */}
          <div className="flex justify-end gap-3 mt-6">
            {!backButtonHide && (
              <button
                className="driver-save-draft-button px-7 py-[0.4rem] btn-white text-[.875rem]"
                onClick={() => setmanualGuideFlag(false)}
              >
                Go Back
              </button>
            )}
            <button
              className="driver-create-guide-button px-7 py-[0.4rem] btn-orange text-[.875rem]"
              type="submit"
              // onClick={handleCreateGuide}
            >
              Create Job Role
            </button>
          </div>
        </div>
      </Form>
    </>
  );
}

export default CreatePrepGuideMainPage;
